<template>
  <div class="page flex-v">
    <HeaderNav :posNavs="posNavs" :actId="4" :topLevel="true"/>
    <div class="container flex">
      <Sider>
        <CommNav :navList="navList" :actId="2" @itemClick="navItemClick" />
      </Sider>
      <div class="layout-right">
        <ScrollBar ref="scrollbar" class="scrollbar main">
          <div class="wrap">
            <div class="lib-box" v-if="loaded">
              <div class="part-top">
                <div class="left">
                  <div class="search-box">
                    <div class="input-wrap">
                      <input v-model="keyword" @input="inputSearch" @keydown.enter="search" placeholder="请输入搜索内容" class="input-txt" type="text">
                      <i class="icon icon-zoom"></i>
                    </div>
                    <button class="btn btn-search" @click="search">搜索</button>
                  </div>
                  <div class="filter">
                    <dl v-for="(item, index) in filterList" :key="index">
                      <dt>{{item.name}}</dt>
                      <dd>
                        <a :class="{'actived': item1.id == filterParams[item.id]}" @click.stop="setItem(item,item1)" v-for="(item1,index1) in item.list">{{item1.name}}</a>
                      </dd>
                    </dl>
                  </div>
                </div>
                <div class="split" v-if="morningData"></div>
                <div class="record" v-if="morningData">
                  <div class="title">晨读记录</div>
                  <div class="img-box-video" @click="$gopage('book_course',{id: morningData.id})">
                    <img :src="morningData.thumbnailUrl">
                    <div class="mask"></div>
                    <i class="icon icon-play-w v-align"></i>
                  </div>
                  <div class="c-info" @click="$gopage('book_course',{id: morningData.id})">
                    <h2>{{morningData.name}}</h2>
                    <p v-if="morningData.book">{{morningData.book.name}}</p>
                  </div>
                </div>
              </div>
              <div class="s-title"><span>{{searchLabel}}</span></div>
              <div class="book-list" v-if="list && list.length">
                <dl @click="choose(item)" :class="{'mr0': index>0 && (index+1)%4==0}" v-for="(item,index) in list">
                  <dt>
                    <img :src="item.coverUrl">
                  </dt>
                  <dd>
                    <div class="name">{{item.name}}</div>
                    <em>共{{item.courseNum || 0}}篇</em>
                  </dd>
                </dl>
              </div>
              <div class="no-data" v-if="(!list || !list.length)">
                <i class="icon icon-empty"></i>
                <div class="tip">没有搜索到您想查看的专辑或专题</div>
              </div>
            </div>
          </div>
        </ScrollBar>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapGetters,
  mapActions
} from 'vuex';

import util from 'libs/util'
import { bookNav } from '@/data/navData';
import bookFilter from '@/services/bookFilter'

export default {
  components: {},
  computed: {
    ...mapGetters([
      'getUserInfo'
    ]),
  },
  data() {
    return {
      navList: bookNav,
      list: [],
      filterList: [],
      filterParams: {},
      keyword: '',
      pageIndex1: 1,
      pageSize: -1,
      bookList: [],
      recomList: [],
      posNavs: [],
      morningData: null, // 晨读记录
      loaded: 0,
      searchLabel: ''
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.init();
    this.setPosNav();
  },
  methods: {
    async init() {
      let filterParams = {};
      let query = this.$route.query;
      let mod = query.mod;
      this.$loading.show();
      let bookCateData = await bookFilter.init();
      bookCateData.forEach((item) => {
        if (item.id == 'grade') {
          let lastGradeId = -1;
          if (this.getUserInfo.lastClickBookLabelId) {
            lastGradeId = this.getUserInfo.lastClickBookLabelId
          } else if (util.getStorage('lastClickBookLabelId')) {
            lastGradeId = util.getStorage('lastClickBookLabelId')
          }
          if (lastGradeId) {
            this.searchLabel = '为您推荐';
            filterParams[item.id] = lastGradeId;
          } else {
            this.searchLabel = '全部'
          }
        } else {
          filterParams[item.id] = -1;
        }
      });
      this.filterList = bookCateData;
      this.filterParams = filterParams;
      this.getList();
      if (this.$user.isLogin()) {
        this.getMoringData();
      }
      this.getRecommList();
    },
    async getMoringData() {
      const res = await this.$post('/course/morningreading.json');
      if (res.status == 200) {
        let morningData = res.data
        this.morningData = morningData;
      }
    },
    search(e) {
      this.reset();
    },
    inputSearch: util.debounce(function() {
      this.$loading.show();
      this.reset()
    }, 500),
    reset() {
      this.pageIndex1 = 1;
      this.isEnd1 = false;
      this.list = []
      this.getList()
    },
    async getList() {
      let params = {
        pageIndex: this.pageIndex1,
        pageSize: this.pageSize,
        keywords: this.keyword
      }
      let filterValues = this.getFilterValue();
      params = {
        ...params,
        ...filterValues
      }
      const res = await this.$post('/book/search.json', params);
      if (res.status == 200) {
        let list = res.data.list || [];
        list = this.$getBookListImg(list)
        this.list = list;
      }
      this.loaded = 1;
      this.$loading.hide();
    },
    async getRecommList() {
      let params = {
        pageIndex: this.pageIndex1,
        pageSize: this.pageSize
      }
      const res = await this.$post('/book/recommend/list.json', params);
      if (res.status == 200) {
        let list = res.data.list || [];
        list = this.$getBookListImg(list)
        this.recomList = list;
      }
    },
    choose(item) {
      this.$gopage('book_detail', {
        id: item.id,
        type: 2
      });
    },
    setPosNav() {
      let posNavs = [{
        id: 1,
        name: '首页',
        pathName: 'index'
      }, {
        id: 2,
        name: '诵读资源'
      }];
      this.posNavs = posNavs;
    },
    setActived(item) {
      this.selectItem = item;
      this.showLayer = !this.showLayer;
    },
    setItem(item, item1) {
      this.filterParams[item.id] = item1.id;
      this.reset();
      this.searchLabel = '全部'
    },
    getFilterValue() {
      let p = {};
      for (let key in this.filterParams) {
        let n = this.filterParams[key];
        if (n != -1) {
          p[key] = n;
        }
      }
      return p;
    },
    navItemClick(item) {
      this.$gopage(item.pathName, {}, true)
    },
    rightNavItemClick(item) {
      this.id = item.id;
      this.selectedItem = item;
      this.$gopage('book_detail', {
        id: this.id
      }, true)
    }
  }
}
</script>
<style lang="less" scoped>
@import '~styles/book/detail.less';
</style>